import { AllItemStatusStateType } from './Types';

export const allItemStatusInitialState: AllItemStatusStateType = {
	loading: false,
	error: null,
	data: null,
};
